module.exports = __webpack_public_path__ + "static/HUB3-56350b11bb76f1c747c297300f6110b9.jpg";